export function removeExtraLetters(value?: string): string | undefined {
  if (!value) return undefined;

  const cleanedUp = value
    .trim()
    .replace(/^lmt/i, '')
    .replace(/^wn/i, '')
    .replace(/^wm/i, '')
    .replaceAll(' ', '')
    .replaceAll('-', '')
    .trim();

  return cleanedUp.length > 0 ? cleanedUp : value;
}
